import { AsyncNamespace, defineEvent, EventTopic, otto } from "@otto-ec/global-resources/nexus";
import { SelectionPage, SelectionState } from "@otto-ec/nexus-registry/selection";

export interface Page {
  sortiertnach?: string;
  l?: string;
  o?: string;
}

export interface FilterSectionLoadEventDeprecated {
  rule: string;
  page: Page;
  ssid?: string;
}

export interface FilterSectionLoadEvent {
  rule: string;
  page: SelectionPage;
  ssid?: string;
  entryRule?: string;
}

export interface FilterSectionInitialLoadedEvent {
  response: Response;
  rule: string;
}

export interface FacetValueTagsLoadedEvent {
  rule: string;
  tags: string[];
}

export interface FilterSectionChangeEvent {
  target: EventTarget;
}

export type HeurekaEvents = {
  filterSection_load_deprecated: EventTopic<FilterSectionLoadEventDeprecated>;
  filterSection_load: EventTopic<FilterSectionLoadEvent>;
  filterSection_loaded: EventTopic<{}>;
  filterSection_initialLoaded: EventTopic<FilterSectionInitialLoadedEvent>;
  filterSection_loadAborted: EventTopic<{}>;
  facetValueTags_loaded: EventTopic<FacetValueTagsLoadedEvent>;
  filterVisibilities_load: EventTopic<FilterSectionLoadEventDeprecated>;

  filterPersonalizationBanner_loaded: EventTopic<{}>;
  refinementBar_loaded: EventTopic<{}>;
  nextBestAction_loaded: EventTopic<[]>;
  nextBestAction_initialized: EventTopic<[]>;

  dresonRule_resolve: EventTopic;
  dresonRule_resolved: EventTopic<SelectionState>;
  dresonRule_resolveAborted: EventTopic;

  filterSection_change: EventTopic<FilterSectionChangeEvent>;

  sliders_initialized: EventTopic<{}>;
}

declare global {
  interface NexusInterfaces {
    heureka: AsyncNamespace<HeurekaEvents>;
  }
}

otto.heureka.assignNamespace({
  filterSection_load_deprecated: defineEvent(),
  filterSection_load: defineEvent(),
  filterSection_loaded: defineEvent(),
  filterSection_initialLoaded: defineEvent(),
  filterSection_loadAborted: defineEvent(),
  facetValueTags_loaded: defineEvent(),
  filterVisibilities_load: defineEvent(),

  filterPersonalizationBanner_loaded: defineEvent(),

  filterSection_change: defineEvent(),

  refinementBar_loaded: defineEvent(),
  nextBestAction_loaded: defineEvent(),
  nextBestAction_initialized: defineEvent(),

  dresonRule_resolve: defineEvent(),
  dresonRule_resolved: defineEvent(),
  dresonRule_resolveAborted: defineEvent(),

  sliders_initialized: defineEvent()
});

export const heureka : HeurekaEvents = otto.heureka;